import { useState } from 'react';
import DetailHeader from '../components/DetailHeader';
import DetailControls from '../components/DetailControls';
import E2eResultsTableTile from '../components/tiles/E2eResultsTableTile';
import E2eAboutTile from '../components/tiles/E2eAboutTile';
import type { Env } from '../types';

// No period selector — E2E shows the latest published run, not a time-windowed
// aggregation. The refresh button still applies.
export default function EnvE2eDetail({ env }: { env: Env }) {
  const [refreshToken, setRefreshToken] = useState(0);
  const bump = () => setRefreshToken((t) => t + 1);

  return (
    <div className="page">
      <DetailHeader
        env={env}
        title="E2E test results"
        subtitle="The latest end-to-end run against the live APIM gateway: a validation suite (one invalid request per rule, expecting 400) and a contact/case lifecycle (create, find, dedup, update, form/case and delete). Each row is one check."
      />
      <DetailControls windowHours={24} onWindowChange={() => undefined} onRefresh={bump} hideWindow />
      <section className="tile-grid tile-grid-wide">
        <E2eResultsTableTile env={env} refreshToken={refreshToken} />
        <E2eAboutTile env={env} refreshToken={refreshToken} />
      </section>
    </div>
  );
}
